module.exports = __webpack_public_path__ + "15e233c51eeab398a856715bd2e6af21.fbx";